
interface parentRows {
    id: string;
    value: unknown;
}

export const paginationQuery = (pageIndex: any, pageSize: any, sorting: any, globalFilter: any, columnFilters: any, OtherValues: any = [], parentRows?: parentRows) => {

    $(".mytrackhide").addClass("d-none");
    $(".mytrackshow").removeClass("d-none");
    $(".mainPlayer").trigger('pause')
    let query: any = {
        page: pageIndex,
        pageSize: pageSize,
        orderBy: { field: sorting ? sorting[0]?.id : '' },
        search: globalFilter,
        orderDirection: (sorting.length > 0 ? sorting[0]?.desc ? 'DESC' : 'ASC' : 'DESC'),
        columnFilters,
        parentRows
    }
    if (OtherValues && OtherValues?.length > 0) {
        OtherValues.forEach((d: any) => {
            query[d.key] = d.value;
        });
    }
    return query;
}


export const handleSearchData = async (
    searching: any,
    setIsError: any,
    setLoading: any,
    setIsRefetching: any,
    setSearchValue: any,
  ) => {
    if (!searching?.length) {
      setLoading(true);
      setIsError(false);
      setIsRefetching(true);
    } else {
      setIsRefetching(true);
    }
    try {
      if (searching?.length > 1) {
        setSearchValue(searching)
        setIsError(false);
      } else {
        if (!searching) {
          setSearchValue('')
        }
      }
    }
    catch (error) {
      console.error('Error in handleSearch:', error);
      setIsError(true);
      return;
    }
    // setIsError(false);
    setLoading(false);
    setIsRefetching(false);
  }
